angular.module('bmsApp.zone')
	.controller('ZoneIndexCtrl', [
		'$filter',
		'$scope',
		'LicenseOptionsSvc',
		'EmployeeOptionsSvc',
		'ZoneSvc',
		'notify',
		'$q',
		function ($filter,
				  $scope,
				  LicenseOptionsSvc,
				  EmployeeOptionsSvc,
				  ZoneSvc,
				  notify,
				  $q) {

			function init() {

				var promises = {
					license: LicenseOptionsSvc.license()
						.then(function (response) {
							self.licenses = response.data.options;
						}),
					employees: EmployeeOptionsSvc.employee()
						.then(function (response) {
							self.options.employees = response.data.options;
						}),
					zone: ZoneSvc.index()
						.then(function (response) {
							self.zones = response.data.zone_collection
						})
				};

				$q.all(promises)
					.then(function () {
						// mark allocated postcodes to hide them in unallocated list
						updatePostcodeAllocations();

						self.loading = false;
					});

			}

			function updatePostcodeAllocations() {
				angular.forEach(self.licenses, function (license) {
					angular.forEach(license.postcodes, function (postcode) {
						var allocated = false;
						angular.forEach(self.zones, function (zone) {
							if (!allocated && !zone.deleted) {
								allocated = $filter('filter')(zone.postcodes, {id: postcode.id}, true).length > 0;
							}
						});
						postcode.allocated = allocated;
					});
				});
			}

			function addZone() {
				self.zones.push({
					postcodes: []
				});
				generateZoneLetters();
			}

			function generateZoneLetters() {
				angular.forEach(self.zones, function(zone, index) {
					angular.extend(zone, {
						label: String.fromCharCode(65 + index)
					});
				});
				console.log(self.zones);
			}

			function removeZone(zone, $index) {
				if (_.has(zone, 'id')) {
					angular.extend(zone, {
						deleted: true
					});
				}
				else {
					self.zones.splice($index, 1)
				}

				updatePostcodeAllocations();
				generateZoneLetters();
			}

			function submit() {
				var params = {
					zones: self.zones,
					license: self.license
				};



				ZoneSvc.save(params)
					.then(function (response) {
						notify({
							message: 'Successfully saved zones'
						});
						init();
					}, function (errors) {
						self.errors = errors;
					});
			}

			var self = $scope.ZoneIndexCtrl = {
				options: {
					licenses: {}
				},
				zones: [],
				methods: {
					init: init,
					updatePostcodeAllocations: updatePostcodeAllocations,
					addZone: addZone,
					removeZone: removeZone,
					submit: submit
				}
			};

		}
	]);
